import React from "react";

const CoursesOnlineHead = () => {
  return (
    <div className="coursesOnlineHead">
      <h3>
        Online <span> German Course</span> with a Live Teacher
      </h3>
      <p>
        Learn German online with our highly qualified Prizma Academy teachers,
        either individually or in a group with fellow German learners from
        around the globe.
      </p>
    </div>
  );
};

export default CoursesOnlineHead;
